import { motion } from 'framer-motion';

interface ConnectionIconProps {
  activeConnection: boolean;
}

export const ConnectionIcon = ({ activeConnection }: ConnectionIconProps) => {
  if (!activeConnection) {
    return (
      <div className="w-8 h-8 flex items-center justify-center z-50">
        <div className="w-4 h-4 rounded-full bg-neutral-400"></div>
      </div>
    );
  }
  return (
    <div className="z-50">
      <div className="flex items-center justify-center">
        <motion.div
          className="w-8 h-8 rounded-full border-2 border-orange-2 bg-transparent"
          animate={{
            scale: [0.5, 1.2, 0.5],
            opacity: [1, 0, 0]
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }}
        ></motion.div>
        <div className="w-4 h-4 rounded-full bg-orange-2 absolute z-50"></div>
      </div>
    </div>
  );
};
